var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header", { staticStyle: { "margin-top": "0" } }, [
        _c("img", {
          ref: "aboutLogo",
          staticClass: "logo",
          attrs: {
            height: "auto",
            src: require("../../resources/logo-disaster@2x.png"),
            width: "200px"
          }
        })
      ]),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c("section", [
        _c("p", {
          staticStyle: { "text-align": "justify" },
          domProps: {
            innerHTML: _vm._s(_vm.$t("customDisasterAbout.firstParagraph"))
          }
        }),
        _vm._v(" "),
        _c("p", {
          staticStyle: { "text-align": "justify" },
          domProps: {
            innerHTML: _vm._s(_vm.$t("customDisasterAbout.secondParagraph"))
          }
        }),
        _vm._v(" "),
        _c("p", {
          staticStyle: { "text-align": "justify" },
          domProps: {
            innerHTML: _vm._s(_vm.$t("customDisasterAbout.thirdParagraph"))
          }
        })
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c("section", { staticStyle: { "text-align": "center" } }, [
        _c("br"),
        _vm._v(" "),
        _c("p", {
          domProps: {
            innerHTML: _vm._s(_vm.$t("customDisasterAbout.dorsIsBasedOnOrs"))
          }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticStyle: { "text-align": "center" } }, [
      _c(
        "a",
        {
          attrs: {
            href: "https://disastermappers.wordpress.com",
            target: "_blanl"
          }
        },
        [
          _c("img", {
            attrs: {
              src: require("../../resources/disastermappers.png"),
              width: "60px",
              height: "60px"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("a", { attrs: { href: "https://www.hotosm.org", target: "_blanl" } }, [
        _c("img", {
          attrs: {
            src: require("../../resources/HOT.png"),
            width: "100px",
            height: "60px"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "a",
        { attrs: { href: "http://www.missingmaps.org", target: "_blanl" } },
        [
          _c("img", {
            attrs: {
              src: require("../../resources/missingmaps.png"),
              width: "141px",
              height: "60px"
            }
          })
        ]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-983f1468", { render: render, staticRenderFns: staticRenderFns })
  }
}